import React, { useEffect, useState } from "react";
import {
    Box,
    CircularProgress,
    Typography,
    Card,
    CardContent,
    IconButton,
} from "@mui/material";
import { useParams } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import EditProgressBar from "../profileModel-DialogBox/EditProgressBar";
import AddWeight from "../AddWeight";
import { getCurrentDateTime } from "../../../modules/ConvertDate";


const WeightProgress = ({ openAddWeight, setOpenAddWeight, weightData, setWeightData, calculateBMI, getCurrentWeight, userData, weightGoalParcent, fetchUserData }) => {
  console.log( openAddWeight, )
  
    const { id } = useParams();
    const [weight, setWeight] = useState({
        type: 'weight',
        value: "",
        userComment: "",
        unit: 'Kgs',
        recordedAt: getCurrentDateTime(),
        createdAt: new Date(),
        updatedAt: new Date(),
        customerId: id
    });
    const [weightSuggestion, setWeightSuggestion] = useState({ weight: 0, loosWeight: "", cases: "" })
    const [openDialog, setOpenDialog] = useState(false);
  console.log("userDatahhhh",userData)
    const onUpdateWeight = () => {

        if (weightData.startWeight == '' || weightData.startWeight == undefined || weightData.startWeight == null) {
            weightData.startWeight = 0;
        }
        var BMIValue = weightData?.startWeight / ((weightData?.height / 100) * (weightData?.height / 100));
        var needToLose = Math.round(weightData?.startWeight - (24 * weightData?.height / 100 * weightData?.height / 100));
        if (weightData?.startWeight > 0) {
            let cases = "";
            if (BMIValue < 18.5) cases = "Underweight";
            else if (BMIValue > 18.5 && BMIValue < 24.9) cases = "Normal";
            else if (BMIValue > 24.9 && BMIValue < 30) cases = "Overweight";
            else if (BMIValue > 30 && BMIValue < 35) cases = "Obese";
            else cases = "Morbidly Obese";
            setWeightSuggestion({
                weight: weightData.startWeight - needToLose,
                loosWeight: Math.abs(needToLose),
                cases
            })
        }
        setOpenDialog(true);
    }
    useEffect(() => {
        getCurrentWeight();
        
    }, []);


    console.log("weightData",weightData)
    return (
        <Box className="flex-1 flex flex-col min-h-96">
            <Card className="flex-1 flex flex-col ">
                <CardContent className="flex-1 flex flex-col justify-between">
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="h6" fontWeight="bold">
                            Weight Progress
                        </Typography>
                        {userData?.height && (
                    <IconButton onClick={() => onUpdateWeight()} size="small">
                        <EditIcon color="primary" />
                    </IconButton>
                )}
                        {/* <IconButton onClick={() => onUpdateWeight()} size="small">
                            <EditIcon color="primary" />
                        </IconButton>
                        )} */}
                    </Box>

                    {userData?.height && userData.dateOfBirth ? (
                        <>
                            <Box item xs={12}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "100%",
                                        height: 200,
                                    }}
                                >
                                    {Math.max(-100, Math.min(weightData.weightGoalPercent || 100, 100)) >= 0 && (
                                        <CircularProgress
                                            variant="determinate"
                                            value={Math.max(-100, Math.min(weightData.weightGoalPercent || 100, 100))}

                                            size={150}
                                            thickness={weightData.weightGoalPercent ? 2 : 0.1}
                                            sx={{ color: weightData.weightGoalPercent ? "secondary.main" : "default" }}
                                        />
                                    )}
                                    <Typography
                                        variant="h5"
                                        sx={{ position: "absolute", color: 'secondary.main' }}
                                    >
                                        {/* {Math.max(-100, Math.min(weightData.weightGoalPercent || 100, 100))}% */}
                                        {Math.max(-100, Math.min(weightData.weightGoalPercent ?? 0, 100))}%
                                    </Typography>
                                </Box>
                            </Box>

                            <Box display="flex" flexDirection="column" justifyContent="space-between">
                                <div className="flex justify-between">
                                    {/* START WEIGHT container */}
                                    <div>
                                        <Typography variant="body1" color="ternary.main">Start</Typography>
                                        <Typography variant="h4">
                                            {weightData.startWeight || 0}
                                            <span style={{ fontSize: '14px', marginTop: '5px', color: "#A9ABB5" }}>
                                                kgs
                                            </span>
                                        </Typography>
                                        <Typography variant="body2" color="ternary.main">
                                            {weightData.startWeightBMI || 0} BMI
                                        </Typography>
                                    </div>

                                    {/* CURRENT WEIGHT container */}
                                    <div>
                                        <Typography variant="body2" color="secondary.main">Current</Typography>
                                        <Typography variant="h4" color="secondary.main">
                                            {weightData.currentWeight || 0}
                                            <span style={{ fontSize: '14px', marginTop: '5px' }}>
                                                kgs
                                            </span>
                                        </Typography>
                                        <Typography variant="body2" color="ternary.main">
                                            {weightData.currentWeightBMI || 0} BMI
                                        </Typography>
                                    </div>
                                    {/* TARGETED WEIGHT container */}
                                    <div>
                                        <Typography variant="body2" color="ternary.main">Target</Typography>
                                        <Typography variant="h4">
                                            {weightData?.targetWeight || 0}
                                            
                                            <span style={{ fontSize: '14px', marginTop: '5px', color: "#A9ABB5" }}>
                                                kgs
                                            </span>
                                        </Typography>
                                        <Typography variant="body2" color="ternary.main">
                                            {weightData?.targetWeight && weightData?.height
                                                ? (weightData.targetWeight / ((weightData.height / 100) * (weightData.height / 100))).toFixed(1)
                                                : 0} BMI
                                        </Typography>
                                    </div>
                                </div>
                            </Box>
                        </>
                    ) : (
                        <Typography className="flex-1 flex justify-center items-center">
                            Please update Basic Detail to view progress..........
                        </Typography>
                    )}
                </CardContent>
            </Card>

            <EditProgressBar
                open={openDialog}
                setOpenDialog={setOpenDialog}
                id={id}
                weightData={weightData}
                setWeightData={setWeightData}
                openAddWeight={openAddWeight}
                setOpenAddWeight={setOpenAddWeight}
                getCurrentWeight={getCurrentWeight}
                fetchUserData={fetchUserData}
                userData={userData}
                weightSuggestion={weightSuggestion}
            />

            <AddWeight
                openAddWeight={openAddWeight}
                setOpenAddWeight={setOpenAddWeight}
                weight={weight}
                setWeight={setWeight}
                setWeightData={setWeightData}
                getCurrentWeight={getCurrentWeight}
                fetchUserData={fetchUserData}
                weightGoalParcent={weightGoalParcent}
                userData={userData}
            />
        </Box>

    );
};



export default WeightProgress;


